import { FC } from 'react';
import StepTitle from './StepTitle';

const UploadLogoTitle: FC = () => (
  <StepTitle
    title="Upload Your Company Logo"
    description="Upload your company logo to display on your job listing. Square images work best. (Maximum file size: 10 MB)"
  />
);

export default UploadLogoTitle;
